import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Constants } from 'src/@smartmanufacturing/common/constants';

@Injectable({
  providedIn: 'root'
})
export class DtServiceService {

  get baseUrl(): string { return Constants.CORE_API_BASE_URL; }

  constructor(private http: HttpClient) { }

  getGroupData(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'Common/GetGroup', data);
  }

  getPlantData(data: any): Observable<any[]> {

    return this.http.post<any[]>(this.baseUrl + 'Common/GetDepartments', data);
  }

  getDeptData(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'Machine/GetDepartmentByPlant', data);
  }

  GetReasons(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'DT/GetReasons', data);
  }
  insertReason(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'DT/InsertReason', data);
  }
  updateReason(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'DT/UpdateReason', data);
  }
  deleteReason(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'DT/DeleteReason', data);
  }

  GetCategory(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'DT/GetCategory', data);
  }
  insertCategory(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'DT/InsertCategory', data);
  }
  updateCategory(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'DT/UpdateCategory', data);
  }
  deleteCategory(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'DT/DeleteCategory', data);
  }

  getTreeTypes(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'DT/GetTreeTypes', data);
  }
  getTree(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'DT/GetTree', data);
  }
  getPlantModelTree(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'DT/GetPlantModelTree', data);
  }
  insertTree(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'DT/InsertTree', data);
  }
  updateTree(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'DT/UpdateTree', data);
  }
  deleteTree(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'DT/DeleteTree', data);
  }
  insertTreeLevel(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'DT/InsertTreeLevel', data);
  }
  getTreeLevel(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'DT/GetTreeLevel', data);
  }
  deleteTreeLevel(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'DT/DeleteTreeLevel', data);
  }
  unitTreeModal(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'Common/GetTreeModal', data);
  }
  getTimedEventFault(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'DT/GetTimedEventFault', data);
  }
  insertTimedEventFault(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'DT/InsertTimedEventFault', data);
  }
  updateTimedEventFault(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'DT/UpdateTimedEventFault', data);
  }
  deleteTimedEventFault(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'DT/DeleteTimedEventFault', data);
  }
  getWasteEventFault(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'DT/GetWasteEventFault', data);
  }
  insertWasteEventFault(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'DT/InsertWasteEventFault', data);
  }
  updateWasteEventFault(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'DT/UpdateWasteEventFault', data);
  }
  deleteWasteEventFault(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'DT/DeleteWasteEventFault', data);
  }
  getReasonTrees(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'DT/GetReasonTrees', data);
  }
  getReasonTree(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'DT/GetReasonTree', data);
  }
  getTreeLevels(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'DT/GetTreeLevels', data);
  }
  getEventReasons(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'DT/GetEventReasons', data);
  }
  insertReasonTree(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'DT/UpsertReasonTree', data);
  }
  updateReasonTree(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'DT/UpdateReasonTree', data);
  }
  deleteReasonTree(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'DT/DeleteReasonTree', data);
  }
  getCategories(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'DT/GetCategories', data);
  }
  getCategoryMapping(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'DT/GetCategoryMapping', data);
  }
  insertCategoryMapping(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'DT/InsertCategoryMapping', data);
  }
  updateCategoryMapping(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'DT/UpdateCategoryMapping', data);
  }
  deleteCategoryMapping(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'DT/DeleteCategoryMapping', data);
  }
  getUnitsByDepartment(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'Machine_Core/GetUnitsByDepartment', data);
  }
}
